// Configuration for CloudCache app
let cached_worker_base = null;

async function isReachable(base, timeoutMs = 5000) {
  if (!base) return false;
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${base}/api/health`, { signal: ctrl.signal });
    return res.ok;
  } catch (_) {
    return false;
  } finally {
    clearTimeout(t);
  }
}

export async function initWorkerBase() {
  if (cached_worker_base) return cached_worker_base;
  const fromSession = sessionStorage.getItem('cc_worker_base');
  if (fromSession && (await isReachable(fromSession))) {
    cached_worker_base = fromSession;
    return cached_worker_base;
  } else if (fromSession) {
    sessionStorage.removeItem('cc_worker_base');
  }
  const candidates = [];
  const envBase = (typeof window !== 'undefined' && window.ENV && window.ENV.WORKER_BASE_URL) ? window.ENV.WORKER_BASE_URL : '';
  if (envBase) candidates.push(envBase);
  // Known good domains
  candidates.push('https://cloudcache.workers.dev');
  candidates.push('https://cloudcache.worker.dev');
  // Legacy (last resort)
  candidates.push('https://cloudcache-worker.lightsia.workers.dev');
  for (const base of candidates) {
    // Deduplicate
    if (!base || candidates.indexOf(base) !== candidates.lastIndexOf(base)) continue;
    // eslint-disable-next-line no-await-in-loop
    if (await isReachable(base)) {
      cached_worker_base = base;
      sessionStorage.setItem('cc_worker_base', base);
      return base;
    }
  }
  // Fallback: empty → UI will surface a friendly message
  cached_worker_base = envBase || '';
  return cached_worker_base;
}

export function getWorkerBase() {
  return cached_worker_base || (typeof window !== 'undefined' && window.ENV && window.ENV.WORKER_BASE_URL) || '';
}

const config = {
  APP_BASE_URL: process.env.REACT_APP_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : ''),
  REQUEST_TIMEOUT_MS: 45000,
  FEATURES: { ENABLE_BILLING: true, ENABLE_OAUTH: true, ENABLE_ZONE_MANAGEMENT: true }
};

export default config;

